import React, { Component } from 'react';
import $ from 'jquery';
import { Link, browserHistory} from 'react-router';
import { Panel,Modal,Button } from 'react-bootstrap';
import { ShareButtons, generateShareIcon } from 'react-share';


const {FacebookShareButton,GooglePlusShareButton,TwitterShareButton} = ShareButtons;
const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');
const GooglePlusIcon = generateShareIcon('google');

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets = 'https://aquadeals.in/admin/assets/';

export default class SubDeals extends Component {
	constructor(props){
		super(props);
			this.state={
					// tid : this.props.params.Tid,
					// type: this.props.params.Type,
					// dtype: this.props.params.DType,
					pdeals: [],
					totdata: '',
					pid: this.props.params.Pid,
					sort: '1',
					img_price: 'price.png',
					img_data: 'Price',
					open: false,
					seo_desc:'',
					cart_count:0,
					loading_gif:false,
					mob_loading:false,
			};
			this.getSort=this.getSort.bind(this);
  			this.getDeviceId=this.getDeviceId.bind(this);
  			this.getCartCount=this.getCartCount.bind(this);
  			this.getNearBy=this.getNearBy.bind(this);

	};
	getSort()
	{
		this.setState({
			loading_gif:true,
		});
		var uid =0;
	    if(localStorage.user_id)
	    {
	      uid=localStorage.getItem('user_id')
	    }
	    else
	    {
	      uid=0;
	    }
		var data1={from: 'mobile_web',uid:uid,sort:this.state.sort, pid: this.state.pid};
		var data2=JSON.stringify(data1);
		// alert("Sort function");
		$.ajax({
  	    	method: 'POST',
    		url: baseUrl+'getNewsearch',
      		dataType:'json',
      		data: {req:data2},
      		success: function(data){
        		if(this.state.sort === 1)
	    		{
	    			var ss = 2;
	    			var img_price = 'down.png';
	    			var img_data = 'High - Low';
	    		}
	    		else
	    		{
	    			 ss = 1;
	    			 img_price = 'up.png';
	    			 img_data ='Low - High';

	    		}
	    		this.setState({
					sort: ss,
					img_price: img_price,
					img_data: img_data,
				});
	    		this.setState({
	       			pdeals:data.products,
	       			totdata: data,
	       			loading_gif:false,
	       		});
  			}.bind(this),
  			error: function(err){
  				// console.log("Error"+err);
  			}
        })
	}
	getNearBy()
	{
		this.setState({
			loading_gif:true,
		});
		var uid =0;
	    if(localStorage.user_id)
	    {
	      uid=localStorage.getItem('user_id')
	    }
	    else
	    {
	      uid=0;
	    }
		var data1={from: 'mobile_web',id:uid,token:localStorage.token,lat:localStorage.getItem('latitude'),long:localStorage.getItem('longitude'),pid: this.state.pid};
		var data2=JSON.stringify(data1);
		$.ajax({
			method: 'POST',
			url: baseUrl+'getNewsearch',
			dataType: 'json',
			data:{req: data2},
			success: function(data)
			{
				this.setState({
	       			pdeals:data.products,
	       			totdata: data,
	       			loading_gif:false,
	       		});
			}.bind(this),
			error: function(err)
			{
				// console.log("Location Error: "+ err);
			}
		});
	}
	getDeviceId()
	{
	    if(localStorage.user_id)
	    {
	        var user_id=localStorage.user_id;
	    }
	    else
	    {
	      user_id=0;
	    }
	    var data1={from: 'mobile_web',id: user_id, device_id: localStorage.getItem('push_device_id')}
	    var data2=JSON.stringify(data1);
	    $.ajax({
	        method: 'POST',
	        url: baseUrl+'getDeviceId',
	        dataType: 'json',
	        data:{req: data2},
	        success: function(data)
	        {
	          
	        },
	        error: function(err)
	        {
	        }
	    });
  	}
  	getCartCount()
	{
		if(localStorage.user_id)
	    {
	        var user_id=localStorage.user_id;
	    }
	    else
	    {
	      user_id=0;
	    }
	    var data1={from: 'mobile_web',id:user_id,token:localStorage.getItem('token')};
	    var data2=JSON.stringify(data1);
	    $.ajax({
	          method: 'POST',
	          url: baseUrl+'cart_count',
	          dataType:'json',
	          data: {req:data2},
	          success: function(data)
	          {
	            console.log(data);
	            this.setState({
	                cart_count:data.cart_count,
	            });
	          }.bind(this),
	          error: function(err){
	          
	          }
	    }) 
	}
	componentDidMount()
	{
		localStorage.removeItem('m_r_p_deals');
		this.setState({
			mob_loading:true,
		})
		if(this.props.params.BrandName && this.props.params.CatName && this.props.params.ProName && this.props.params.Pid && !this.props.params.DType)
  		{
  			localStorage.setItem('subdeals','/subdeals/'+this.props.params.BrandName+'/'+this.props.params.CatName+'/'+this.props.params.ProName+'/'+this.props.params.Pid)
  		}
  		else if(this.props.params.BrandName && this.props.params.CatName && this.props.params.DType && this.props.params.ProName && this.props.params.Pid)
		{
			localStorage.setItem('subdeals','/subdeals/'+this.props.params.BrandName+'/'+this.props.params.CatName+'/'+this.props.params.DType+'/'+this.props.params.ProName+'/'+this.props.params.Pid)	
		}

		if(screen.width >= 800 && this.props.params.BrandName && this.props.params.CatName && this.props.params.ProName && this.props.params.DType && this.props.params.Pid )
		{
			window.location.href="/web/subdeals/"+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.DType+"/"+this.props.params.ProName+"/"+this.props.params.Pid;
		}
	    if(localStorage.user_id && localStorage.token)
	    {
	      this.getCartCount();
	    }
	    var uid =0;
	    if(localStorage.user_id)
	    {
	      uid=localStorage.getItem('user_id')
	    }
	    else
	    {
	      uid=0;
	    }
	    this.getDeviceId();
	    var data1={from: 'mobile_web',uid:uid,pid: this.state.pid};
	    var data2=JSON.stringify(data1);
	    $.ajax({
	          method: 'POST',
	          url: baseUrl+'getNewsearch',
	          dataType:'json',
	          data: {req:data2},
	          success: function(data)
	          {
	    		this.setState({
		              pdeals:data.products,
		              totdata: data,
		              mob_loading:false,
		        });
	          }.bind(this),
		      error: function(err)
		      {
		          // console.log("Error"+err);
		      }
	    });
	}
	render(){
		var products = this.state.pdeals.map((product,index) => (<ProductsList key={index} data={product} onUpdate={()=>this.getCartCount()} />));
		document.title =this.state.totdata.product_name + " - Products | AquaDeals ";
		document.getElementsByTagName("META")[2].content="Browse best deals from "+this.state.totdata.product_name+" in AquaDeals.Contact customer care for any queries on these Aqua products and order online"; 
		return(
		<div className="mob_deals subdeals_page">
			<div className="page_hdr">
				<div className="container-fluid">
					<h5><Link onClick={()=>{browserHistory.goBack()}}><i><img src={baseAssets+'images/web_imgs/back_arrow.png'} width="18px" alt=""/></i></Link> {this.state.totdata.product_name} </h5>
					<a href="/" className="home_logo1"><img src={baseAssets+'images/web_imgs/home1.png'} alt="Home" /></a>
					<a className="mob_cart_btn" href="/mycart">
						<img alt="" src={baseAssets+'icons/web_icons/cart_icon.png'} />
						{this.state.cart_count > 0 ? <span className={this.state.cart_count > 9 ? "mob_cart_count1" : "mob_cart_count"}>{this.state.cart_count}</span> : ''}
					</a>
				</div>
			</div>
			<div className="pag_cntnt">&nbsp;</div>
			{this.state.mob_loading ? <div className="mob_loading"><img src={baseAssets+'images/web_imgs/mob_loading.gif'} alt="Loading" /></div> : ''}
			{this.state.loading_gif ? <i className="loading_gif"><img src={baseAssets+'images/loading_more.gif'} alt="Loading" /></i> : ''}
			<section className="subdeals_cnt">
				{products}
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
			</section>
			<section className="seed_sort dsl_srt new_dsl">
				<ul>
					<li style={{cursor: 'pointer'}} className="col-md-12 col-xs-12 col-sm-12"><a onClick={this.getSort}><img src={baseAssets+'images/web_imgs/'+this.state.img_price} alt="sort" /><span>{this.state.img_data}</span></a></li>
					{/*<li style={{cursor: 'pointer'}} className="col-md-6 col-xs-6 col-sm-6"><a onClick={this.getNearBy}><img src={baseAssets+'images/web_imgs/nearby.png'} alt="nearby" /> <span>Nearby</span> </a></li>*/}
				</ul>
			</section>
		</div>
	);
	}
}


	class ProductsList extends Component {
		constructor(props)
		{
		    super(props);
		    this.state={
		      open: false,
		      msg: '',
		      shareUrl: '',
		      cart_count:'',
		      clearcart_status:false,
		      already_added_status:false,
		    }
		    this.shareFunc=this.ShareFunc.bind(this);
		    this.addToCart=this.addToCart.bind(this);
		    this.updateCartCount=this.updateCartCount.bind(this);
		    this.close=this.close.bind(this);
		    this.replaceCartItems=this.replaceCartItems.bind(this);
		    this.addToQuickCart=this.addToQuickCart.bind(this);
		    this.addToQuickCart_Onload=this.addToQuickCart_Onload.bind(this);
	  	}
	  	componentDidMount()
	  	{
			window.scrollTo(0, 0);					  		
	  		if(localStorage.user_id && localStorage.token && localStorage.quickbuy_onload)
		    {
		    	this.addToQuickCart_Onload();
		    	localStorage.removeItem('quickbuy_onload');
				localStorage.removeItem('quickbuy_deal_id');	
		    }
	  	}
	  	ShareFunc(evnt)
		{
		    var data1={from: 'mobile_web',type:1,did:evnt};
		    var data2=JSON.stringify(data1);
		    $.ajax({
		          method: 'POST',
		          url: baseUrl+'createTinyurl',
		          dataType:'json',
		          data: {req:data2},
		          success: function(data)
		          {
		            // console.log(data);
		            this.setState({
		              msg: data.msg,
		              shareUrl: data.tinyurl,
		            })
		          }.bind(this),
		          error: function(err)
		          {
		          // console.log("Error"+err);
		          }
		        });
			    // ReactGA.event({
			    //   category: 'Feed Deals List',
			    //   action: 'Clicked Share Button',
			    // });
			    this.setState({
			      open: !this.state.open 
		    	});
	    		setTimeout(() => {this.setState({open: false}); }, 5000);
		}
		close()
		{
		 	this.setState({
		  		clearcart_status:false,
		  		already_added_status:false,
		  	});
		}
		updateCartCount()
		{
		  	this.props.onUpdate();
		}
		addToCart(deal_id)
		{
		  	if(!localStorage.user_id && !localStorage.token)
		  	{
		  		browserHistory.push('/login');
			}
		  	else
		  	{
                 if(localStorage.user_id)
			    {
			        var user_id=localStorage.user_id;
			    }
			    else
			    {
			      user_id=0;
			    }
			    if(localStorage.source)
      {
        var source=localStorage.getItem('source');
      }
      else
      {
        source='';
      }
      if(localStorage.campaign)
      {
        var campaign=localStorage.getItem('campaign');
      }
      else
      {
        campaign='';
      }
      if(localStorage.url_id)
      {
        var url_id=localStorage.getItem('url_id');
      }
      else
      {
        url_id='';
      }
			  	var data1={from: 'mobile_web',id:user_id,token:localStorage.getItem('token'),deal_id:deal_id,deal_type:1,source:source,campaign:campaign,url_id:url_id}
				var data2=JSON.stringify(data1);
				$.ajax({
					method:'post',
					dataType:'json',
					url: baseUrl+'quickBuy',
					data:{req:data2},
					success:function(data)
					{
						if(data.status==="success")
						{
							this.updateCartCount();
							browserHistory.push('/mycart');
						}
						else if(data.status==="error" && data.cart_flag===0)
						{
							this.setState({
								clearcart_status: true,
							});
						}
						else if(data.status==="error" && data.message==="Product already added to the cart")
						{
							this.setState({
								already_added_status: true,
							});
						}
						else if(data.status==="error" && data.message==="Token mismatch")
						{
							localStorage.removeItem('token');
							localStorage.removeItem('user_id');
							browserHistory.push('/login');
						}
					}.bind(this),
					error:function(err)
					{

					}
				});
		  	}
		  	
		}
		addToQuickCart(deal_id)
	  	{
		  	if(!localStorage.user_id && !localStorage.token)
		  	{
		  		localStorage.setItem('quickbuy_onload','1');
	  			localStorage.setItem('quickbuy_deal_id',deal_id);
		  		browserHistory.push('/login');
			}
			else
			{
				if(localStorage.user_id)
			    {
			        var user_id=localStorage.user_id;
			    }
			    else
			    {
			      user_id=0;
			    }
			    if(localStorage.source)
			      {
			        var source=localStorage.getItem('source');
			      }
			      else
			      {
			        source='';
			      }
			      if(localStorage.campaign)
			      {
			        var campaign=localStorage.getItem('campaign');
			      }
			      else
			      {
			        campaign='';
			      }
			      if(localStorage.url_id)
			      {
			        var url_id=localStorage.getItem('url_id');
			      }
			      else
			      {
			        url_id='';
			      }
			  	var data1={from: 'mobile_web',id:user_id,token:localStorage.getItem('token'),deal_id:deal_id,deal_type:1,source:source,campaign:campaign,url_id:url_id}
				var data2=JSON.stringify(data1);
				$.ajax({
					method:'post',
					dataType:'json',
					url: baseUrl+'addToQCart',
					data:{req:data2},
					success:function(data)
					{
						if(data.status==="success")
						{
							this.updateCartCount();
							localStorage.removeItem('quickbuy_onload');
							localStorage.removeItem('quickbuy_deal_id');
							browserHistory.push('/quickcart');
						}
						else if(data.status==="error" && data.cart_flag===0)
						{
							this.setState({
								clearcart_status: true,
							});
							localStorage.removeItem('quickbuy_onload');
							localStorage.removeItem('quickbuy_deal_id');
						}
						else if(data.status==="error" && data.message==="Product already added to the cart")
						{
							this.setState({
								already_added_status: true,
							});
							localStorage.removeItem('quickbuy_onload');
							localStorage.removeItem('quickbuy_deal_id');
						}
					}.bind(this),
					error:function(err)
					{
					}
				});
			}
		}
		addToQuickCart_Onload()
		{
		  	if(localStorage.source)
	      	{
		        var source=localStorage.getItem('source');
	      	}
	      	else
	      	{
	       		source='';
	      	}
	      	if(localStorage.campaign)
	      	{
	        	var campaign=localStorage.getItem('campaign');
	      	}
	      	else
	      	{
	        	campaign='';
	      	}
	      	if(localStorage.url_id)
	      	{
	        	var url_id=localStorage.getItem('url_id');
	      	}
	      	else
		    {
		        url_id='';
		    }
		    if(localStorage.quickbuy_deal_id)
			{
				var deal_id=localStorage.quickbuy_deal_id;
			}
			else
			{
				deal_id=0;
			}
		  	if(!localStorage.user_id && !localStorage.token)
		  	{
		  		localStorage.setItem('quickbuy_onload','1');
		  		localStorage.setItem('quickbuy_deal_id',deal_id);
		  		browserHistory.push('/login');
			}
			else
			{
				if(localStorage.user_id)
				{
					var uid=localStorage.user_id;
				}
				else
				{
					uid=0;
				}
				var data1={from:'mobile_web',id:uid,token:localStorage.getItem('token'),deal_id:deal_id,deal_type:1,source:source,campaign:campaign,url_id:url_id}
				var data2=JSON.stringify(data1);
				$.ajax({
					method:'post',
					dataType:'json',
					url: baseUrl+'addToQCart',
					data:{req:data2},
					success:function(data)
					{
						if(data.status==="success")
						{
							this.updateCartCount();
							browserHistory.push('/quickcart');
							localStorage.removeItem('quickbuy_onload');
							localStorage.removeItem('quickbuy_deal_id');
						}
						else if(data.status==="error" && data.cart_flag===0)
						{
							this.setState({
								clearcart_status: true,
							});
							localStorage.removeItem('quickbuy_onload');
							localStorage.removeItem('quickbuy_deal_id');
						}
						else if(data.status==="error" && data.message==="Product already added to the cart")
						{
							this.setState({
								already_added_status: true,
							});
							localStorage.removeItem('quickbuy_onload');
							localStorage.removeItem('quickbuy_deal_id');
						}
						localStorage.removeItem('quickbuy_onload');
						localStorage.removeItem('quickbuy_deal_id');
					}.bind(this),
					error:function(err)
					{

					}
				});
			}
			localStorage.removeItem('quickbuy_onload');
			localStorage.removeItem('quickbuy_deal_id');
	  	}
		replaceCartItems(deal_id,quantity)
		{
            if(localStorage.source)
		      {
		        var source=localStorage.getItem('source');
		      }
		      else
		      {
		        source='';
		      }
		      if(localStorage.campaign)
		      {
		        var campaign=localStorage.getItem('campaign');
		      }
		      else
		      {
		        campaign='';
		      }
		      if(localStorage.url_id)
		      {
		        var url_id=localStorage.getItem('url_id');
		      }
		      else
		      {
		        url_id='';
		      }
            if(localStorage.user_id)
		    {
		        var user_id=localStorage.user_id;
		    }
		    else
		    {
		      user_id=0;
		    }
		  	var data1={from: 'mobile_web',id:user_id,token:localStorage.getItem('token'),deal_id:deal_id,deal_type:1,quantity:quantity,pl_size:0,salinity:0,pickup_date:0,source:source,campaign:campaign,url_id:url_id}
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'post',
				dataType:'json',
				url: baseUrl+'replaceCart',
				data:{req:data2},
				success:function(data)
				{
					if(data.status==="success")
					{
						this.setState({
							clearcart_status:false,
						});
						browserHistory.push('/mycart');
					}
				}.bind(this),
				error:function(err)
				{

				}
			});
		}
	render(){
		var mydata=this.props.data;
		 // var shareUrl = "https://aqua.deals/pdetails/"+mydata.url_dtype_name+"/"+mydata.url_cat_name+"/"+mydata.url_product_name+"/"+mydata.pro_id+"/"+mydata.id;
		 // var title = "AquaDeals";
		 var shareUrl= this.state.shareUrl;
		 var title="Hey! Click here " + shareUrl + " to check "+mydata.title+" from AquaDeals.";
		 // var description= shareUrl;    
		return (
			<div className="list_card">
				{mydata.promo_ribbion ? <i className="ribbon_img"><img src={baseAssets+'images/web_imgs/'+mydata.promo_ribbion} alt="" /></i> : ''}
				<Link to={"/pdetails/"+mydata.url_dtype_name+"/"+mydata.url_cat_name+"/"+mydata.url_brand_name+"/"+mydata.url_product_name+"/"+mydata.pro_id+"/"+mydata.id} >
					<div className="list_img">
						<img src={baseAssets+'images/product_imgs/'+mydata.image} alt="AquaDeals" role="presentation" />
					</div>
					{mydata.ad_guarantee_flag==='1' ? <span className="pdeals_adguarantee"><img src={baseAssets+'images/product_imgs/ad_guarantee.png'} alt=" " /></span> : ''}
					<div className="list_txt">
						{mydata.brand_name ? <h4>{mydata.brand_name}</h4> : ''} 
						{mydata.title ? <h5>{mydata.title}</h5> : ''}
						{/* <h5>&#8377;{mydata.discount_amount} </h5> */}
						{/* <p><span className="offer_old">&#8377;{mydata.mrp}</span> <span className="offer_new"> &#8377;{mydata.act_price}</span></p> */}
						{/*<h3>{mydata.full_aquacash_back_disc}</h3>*/}
						{/*<h3>Starting at &#8377;{mydata.act_price}</h3> */}
						{/* {mydata.act_price ? <h3>aquacash discount &#8377;{mydata.pricediff}</h3> : <h5>MRP &#8377; {mydata.mrp}</h5>} */}
						{mydata.pricediff ==="" ? <h3>MRP &#8377; {mydata.mrp}</h3> : ''}
						{mydata.pricediff ? <h3>aquacash discount &#8377; {mydata.pricediff}</h3> : ''}
						{mydata.over_rate >=1 ? <div>
							<div className="str_blk"><i className="glyphicon glyphicon-star glyphicon_sub_star"></i>{mydata.over_rate} </div>
							{mydata.deal_views >0 ? <div className="views_eye"><img src={baseAssets+'images/web_imgs/views.png'} width="17px" role="presentation"/> {mydata.deal_views} {mydata.deal_views >1 ? ' Views' : ' View'}</div> : ''}
							</div> : <div>
							<div className="str_blk">
							<i className="glyphicon glyphicon-star no_star"></i>
							</div>
							{mydata.deal_views >0 ? <div className="views_eye"><img src={baseAssets+'images/web_imgs/views.png'} width="17px" role="presentation"/> {mydata.deal_views} {mydata.deal_views >1 ? ' Views' : ' View'}</div> : ''}
							</div>}
					</div>
				</Link>
				<Link className="share_list" onClick={()=>{this.ShareFunc(mydata.id)}}><img src={baseAssets+'images/web_imgs/share1.png'} alt="share" /></Link>
				
				{/*<a className="quick_buy_img" onClick={()=>this.addToCart(mydata.id)}><img src={baseAssets+"images/icons/quick_buy.png"} alt=" " width="40px" /></a>*/}
				<a className="quick_buy_img" onClick={()=>this.addToQuickCart(mydata.id)}><img src={require('./../../../assets/images/quick_buy.png')} alt=" " width="40" /></a>
				<div>
				      <Panel className="share_panel" collapsible expanded={this.state.open}>
				          <FacebookShareButton url={shareUrl} quote={title} className="test_share">
				            <FacebookIcon size={32} round />
				          </FacebookShareButton>
				          <TwitterShareButton url={shareUrl} quote={title} className="test_share">
				            <TwitterIcon size={32} round />
				          </TwitterShareButton>
				          <GooglePlusShareButton url={shareUrl} className="test_share">
				            <GooglePlusIcon size={32} round />
				          </GooglePlusShareButton>
				       </Panel>
				</div>
				{/* Modal for Replaceing the other cart items */}
			    <Modal className="m_pro_full_dtls_modal"  show={this.state.clearcart_status} onHide={this.close}  >
					<Modal.Header closeButton>
			    		<Modal.Title style={{fontSize: '16px',color:'#333'}}>Alert</Modal.Title>
			  		</Modal.Header>
			  		<Modal.Body>
			  			<h4 style={{fontSize:'14px', color:'#333'}}>You can't have multiple seller items in the cart. Empty existing cart & add this item {mydata.title}?</h4>
			  		</Modal.Body>
			  		<Modal.Footer className="modal_footer">
							<Button style={{background: 'none',border:'none',color:'#ff742a'}} onClick={this.close}>NO</Button>
							<a><Button style={{background:'none',border:'none',color: '#ff742a'}} onClick={()=>{this.replaceCartItems(mydata.id,mydata.min_qty)}}>YES</Button></a>
			  		</Modal.Footer>
				</Modal>

				{/* Modal for Showing the response of Already existing product */}
				<Modal className="m_pro_full_dtls_modal"  show={this.state.already_added_status} onHide={this.close}  >
					<Modal.Header closeButton>
			    		<Modal.Title style={{fontSize: '16px',color:'#333'}}>Alert</Modal.Title>
			  		</Modal.Header> 
			  		<Modal.Body>
			  			<h4 style={{fontSize:'14px', color:'#333'}}>Product already added to the cart</h4>
			  		</Modal.Body>
			  		<Modal.Footer className="modal_footer">
							<Button style={{background: 'none',border:'none',color:'#ff742a'}} onClick={this.close}>OK</Button>
					</Modal.Footer>
				</Modal>
			</div>
		);
		
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/Categories/Feed/subdeals.js
 **/